import React from 'react';
import { cn } from '@/lib/utils';

interface MessageBubbleProps {
  children: React.ReactNode;
  isOutgoing: boolean;
  className?: string;
}

// Message tail SVG component
function WhaleTail({ isOutgoing, className }: { isOutgoing: boolean; className?: string }) {
  return (
    <svg
      width="44"
      height="46"
      viewBox="0 0 44 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("absolute w-6 h-6 z-10", className)}
      style={{
        [isOutgoing ? 'right' : 'left']: '-13px',
        bottom: '0px',
        transform: isOutgoing ? 'scaleX(1)' : 'scaleX(-1)',
      }}
    >
      <path
        d="M42.1871 40.8432C26.1396 31.3025 19.8723 19.772 19.8723 0.499899L5.21504 9.10304C4.78029 9.35822 4.45794 9.76817 4.31249 10.2508L0.147956 24.0712C0.0758049 24.3106 0.0491992 24.5615 0.0695158 24.8107L1.19246 38.5875C1.23967 39.1666 1.53173 39.6994 2.01488 40.0222C12.912 47.302 32.4049 46.3676 41.8814 44.0626C43.4896 43.6714 43.6098 41.689 42.1871 40.8432Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MessageBubble({ children, isOutgoing, className }: MessageBubbleProps) {
  return (
    <div className={cn("flex", isOutgoing ? "justify-end" : "justify-start")}>
      <div className="relative">
        <div
          className={cn(
            "max-w-xs lg:max-w-lg p-4 rounded-3xl relative z-11",
            isOutgoing
              ? "bg-info-solid text-on-accent rounded-br-md"
              : "bg-surface-bubble text-surface-bubble-foreground rounded-bl-md",
            className
          )}
        >
          {children}
        </div>
        <WhaleTail
          isOutgoing={isOutgoing}
          className={isOutgoing ? "text-info-solid" : "text-surface-bubble"}
        />
      </div>
    </div>
  );
}

